import './index.erb';
import './index.rb';

/*
 * Os dois eventos do cartao de sugestoes.
 *
 * Nao estao no plano do Amplitude -- vao pelo nome literal, como no UniQ e na Mesa. O plano
 * e de outro time; ate la o nome escrito aqui e o contrato, e o `index.test.js` e o que o
 * segura.
 *
 * `source platform` vai explicito: diferente do UniQ (plugin) e do bord (monkey patch),
 * nenhum tracker do odin carimba isso, e sem a propriedade os tres produtos deixam de ser
 * comparaveis no painel.
 */
const TRACKING = {
  shown: 'filter suggestion shown',
  accepted: 'filter suggestion accepted',
  platform: 'odin'
};

/*
 * A impressao sai uma vez por busca sem precisar de chave de deduplicacao: o cartao so
 * existe no HTML de uma pagina que voltou zero, e cada busca e um carregamento novo.
 *
 * O clique navega de verdade (`<a href>`), mas o evento nao se perde: o `amplitude-js`
 * herdado grava os eventos pendentes no localStorage antes de mandar (`saveEvents`, ligado
 * por padrao) e reenvia no proximo carregamento.
 */
function track(eventName, data) {
  if (!window.UserTracker || typeof window.UserTracker.emit !== 'function') {
    return false;
  }

  window.UserTracker.emit('event', {
    eventName: eventName,
    data: { ...data, 'source platform': TRACKING.platform }
  });

  return true;
}

function chipsOf(root) {
  return Array.from(root.querySelectorAll('.js-filter-suggestion'));
}

export function trackShown(root) {
  track(TRACKING.shown, {
    'suggestions count': Number(root.getAttribute('data-count')),
    // Lida dos proprios chips, em ordem: eles sao a unica fonte do que foi removido.
    'removed filters': chipsOf(root).map(chip =>
      chip.getAttribute('data-removed')
    ),
    approximate: root.getAttribute('data-approximate') === 'true'
  });
}

export function trackAccepted(chip) {
  track(TRACKING.accepted, {
    'removed filter': chip.getAttribute('data-removed'),
    // 1-based: e o ranking que o Suricate entregou, nao um indice de array.
    'suggestion position': Number(chip.getAttribute('data-position')),
    'suggested total': Number(chip.getAttribute('data-total'))
  });
}

export function setup(root) {
  if (!root) {
    return;
  }

  trackShown(root);

  chipsOf(root).forEach(chip => {
    chip.addEventListener('click', () => trackAccepted(chip));
  });
}

/*
 * Sem listener: este modulo vive num pack de pagina, que o Turbolinks reexecuta a cada render
 * (`_footer_content.html.erb` so passa `data-turbolinks-eval="false"` no pack `application`).
 * `DOMContentLoaded` ja disparou na primeira carga e nunca dispara de novo, entao amarrar nele
 * deixaria os dois eventos mudos em toda navegacao -- submit do filtro, paginacao e o proprio
 * clique num chip. O bind morre com o `<body>` antigo, entao nada acumula. E o mesmo padrao de
 * `pages/questions/components/question_type_tabs/index.js`.
 */
setup(document.querySelector('[data-filter-suggestions]'));
